module.exports = __webpack_public_path__ + "img/logo.2b049ea5.svg";